import { DatePipe } from '@angular/common';
import { Component,Inject } from '@angular/core';
import { FormControl,FormGroup,Validators } from '@angular/forms';
import { MatLegacyDialogConfig as MatDialogConfig,MatLegacyDialogRef as MatDialogRef,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Store } from '@ngrx/store';
import { isArray } from 'chart.js/helpers';

import { saveAs } from 'file-saver';
import moment,{ Moment } from 'moment';
import { BehaviorSubject,combineLatest,firstValueFrom,Observable,of } from 'rxjs';
import { distinctUntilChanged,filter,map,shareReplay,switchMap,take } from 'rxjs/operators';
import {
getJobSpecification,
getJobSpecificationFetched
} from 'src/app/dave-data-module/State/selectors/job-specification.selector';
import { getUser } from 'src/app/dave-data-module/State/selectors/users.selectors';
import { FilterOption,FILTER_TYPE_SEARCH_MULTI_SELECT,IFilterTypeSearchMultiSelectValue } from 'src/app/dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { CommissionMeta } from 'src/app/helper/page-metadata';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { FilterTypes } from 'src/app/services/default-filter.service';
import { ClockInEntity } from '../../../dave-data-module/entities/clock-in.entity';
import { CommissionEntity } from '../../../dave-data-module/entities/commission.entity';
import { EmployeeEntity } from '../../../dave-data-module/entities/employee.entity';
import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { EmployeeResolver } from '../../../dave-data-module/guards/employee.resolver';
import { JobSpecificationResolver } from '../../../dave-data-module/guards/job-specification.resolver';
import { FrontendDate } from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { ClockInDataService } from '../../../dave-data-module/services/clockin-data.service';
import { HttpService } from '../../../dave-data-module/services/http.service';
import { State } from '../../../dave-data-module/State';
import { BaseActionTypes } from "../../../dave-data-module/State/actions/base.actions";
import { getToken } from '../../../dave-data-module/State/selectors/base.selectors';
import {
getCommissionsActive,
getCommissionsFetched
} from '../../../dave-data-module/State/selectors/commission.selector';
import { getEmployeesActive,getEmployeesActiveSortedByNameStartWithMe,getEmployeesFetched } from '../../../dave-data-module/State/selectors/employees.selectors';
import { IDetailListTemplateData } from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import {
CustomPropertyType
} from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/profile-template/profile-template.component';
import { appMatDialogDefaultConfig,compareArrays,isNotNullOrUndefined } from "../../../helper/helper";
import { arrayLengthValidator } from "../../../helper/validation.helper";
import { LoadingService } from "../../../services/loading.service";

interface CsvExportFilter {
    [FilterTypes.Commissions]: IFilterTypeSearchMultiSelectValue<number>[];
    [FilterTypes.JobSpecificationIds]: IFilterTypeSearchMultiSelectValue<number>[];
}

export enum ClockInExportType {
    all,
    hourList,
    commission,
}
export interface CsvExportDialogComponentDialogData {
    exportType: ClockInExportType;
    selectedCommissionId?: number;
}
@Component({
    selector: 'app-csv-export-dialog',
    templateUrl: './csv-export-dialog.component.html',
    styleUrls: ['./csv-export-dialog.component.scss'],
    providers: [DatePipe],
})
export class CsvExportDialogComponent {
    public static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        maxWidth: '100%',
        width: '50%',
        minWidth: '600px',
        maxHeight: 'calc(100vh - 3.5rem)',
    };
    private employeesInitialised$ = new BehaviorSubject(false);
    public Form = new FormGroup({
        FromDate: new FormControl<Moment>(moment(), [Validators.required]),
        ToDate: new FormControl<Moment>(moment(), [Validators.required]),
        Employees: new FormControl<EmployeeEntity[]>([]),
        Commission: new FormControl<{ Id: number }>(null),
        ByClockInType: new FormControl<boolean>(false),
        WithoutEmptyWorkdays: new FormControl<boolean>(false),
    });
    protected filterSettings$: Observable<FilterOption[]> = combineLatest([
        getFetched$(this.store, getCommissionsFetched, getCommissionsActive),
        getFetched$(this.store, getJobSpecificationFetched, getJobSpecification),
        this.cls.getMultiple$('Commission'),
    ]).pipe(
        filter((v) => v.every(isNotNullOrUndefined)),
        map(([commissions, jobs, commissionLabel]) => {
            let commissionValues: IFilterTypeSearchMultiSelectValue<number>[] = commissions.map((c) => ({
                label: c.optionLabel,
                id: c.Id,
            }));
            let jobValues: IFilterTypeSearchMultiSelectValue<number>[] = jobs.map((c) => ({
                label: c.Name,
                id: c.Id,
            }));
            return [
                {
                    Name: FilterTypes.Commissions,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: commissionLabel,
                    Icon: CommissionMeta.Icon,
                    Values: commissionValues,
                },
                {
                    Name: FilterTypes.JobSpecificationIds,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Jobbezeichnung',
                    Icon: 'id-card' as IconProp,
                    Values: jobValues,
                },
            ];
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected filterValues$ = new BehaviorSubject<CsvExportFilter>({
        [FilterTypes.Commissions]: [],
        [FilterTypes.JobSpecificationIds]: [],
    });
    protected filterAmount$ = this.filterValues$.pipe(
        map((filter) =>
            Object.values(filter).reduce((prev, curr) => {
                if (curr) {
                    if (isArray(curr)) {
                        if (curr.length) {
                            return prev + 1;
                        }
                    } else {
                        return prev + 1;
                    }
                }
                return prev;
            }, 0),
        ),
    );
    protected filteredEmployees$ = combineLatest([
        this.store.select(getEmployeesActiveSortedByNameStartWithMe),
        this.store.select(getUser),
        this.filterValues$,
        this.filterValues$.pipe(
            map((filter) => (filter[FilterTypes.Commissions] || []).map((c) => c.id).sort()),
            distinctUntilChanged((a, b) => compareArrays(a, b)),
            switchMap((commissionIds) => (commissionIds.length ? this.clockInDataService.getByCommissions$(commissionIds) : of([] as ClockInEntity[]))),
        ),
    ]).pipe(
        map(([employees, loggedInUser, filter, clockIns]) => {
            let filteredEmployees = employees.filter((e) => e.PartnerId === (loggedInUser ? loggedInUser.PartnerId : 0));
            if (filter[FilterTypes.Commissions]?.length) {
                filteredEmployees = filteredEmployees.filter((e) => clockIns.some((f) => e.Id === f.EmployeeId));
            }
            if (filter[FilterTypes.JobSpecificationIds]?.length) {
                filteredEmployees = filteredEmployees.filter((e) => e.JobSpecificationId && filter[FilterTypes.JobSpecificationIds].some((f) => f.id === e.JobSpecificationId));
            }
            this.Form.controls.Employees.setValue(filteredEmployees);
            return filteredEmployees;
        }),
    );
    TemplateData$: Observable<IDetailListTemplateData>;
    private readonly apiEndpoint: string;
    private readonly responseFileNameOverride: string;

    protected readonly showEmployeeSelect: boolean;
    protected readonly showCommissionSelect: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        dialogData: CsvExportDialogComponentDialogData,
        private store: Store<State>,
        private httpService: HttpService,
        datePipe: DatePipe,
        private dialogRef: MatDialogRef<CsvExportDialogComponent>,
        protected ls: LoadingService,
        protected cls: CustomLabelService,
        employeeResolver: EmployeeResolver,
        commissionResolver: CommissionResolver,
        jobSpecificationResolver: JobSpecificationResolver,
        private clockInDataService: ClockInDataService,
    ) {
        if (isNotNullOrUndefined(dialogData.exportType)) {
            if (dialogData.exportType !== ClockInExportType.commission && isNotNullOrUndefined(dialogData.selectedCommissionId)) {
                throw new Error('SelectedCommissionId not allowed for export type ' + ClockInExportType[dialogData.exportType]);
            }
            if (dialogData.selectedCommissionId) {
                this.Form.controls.Commission.setValue({ Id: dialogData.selectedCommissionId });
            }
            this.apiEndpoint = dialogData.exportType === ClockInExportType.all ? 'All' : 'HourList';
            let fileName = 'Arbeitszeitexport-' + datePipe.transform(Date.now(), 'yyyy-MM-dd');
            switch (dialogData.exportType) {
                case ClockInExportType.all:
                case ClockInExportType.commission:
                    fileName += '.csv';
                    break;
                case ClockInExportType.hourList:
                    fileName += '.zip';
                    break;
            }
            this.responseFileNameOverride = fileName;
            this.showEmployeeSelect = dialogData.exportType !== ClockInExportType.commission;

            if (dialogData.exportType === ClockInExportType.commission) {
                this.Form.controls.Commission.addValidators(Validators.required);
            } else {
                this.Form.controls.Employees.addValidators(arrayLengthValidator(1));
            }
            firstValueFrom(getFetched$(store, getEmployeesFetched, getEmployeesActive, employeeResolver)).then((employees) => {
                if (dialogData.exportType !== ClockInExportType.commission) {
                    this.Form.controls.Employees.reset(employees);
                }
                this.employeesInitialised$.next(true);
            });
            this.TemplateData$ = this.employeesInitialised$.pipe(
                filter((v) => v),
                switchMap(() => combineLatest([cls.getSingle$('Commission'), getFetched$(store, getCommissionsFetched, getCommissionsActive)])),
                map(([commissionLabel, activeCommissions]) => ({
                    Properties: [
                        {
                            key: 'Zeitraum',
                            formControl: this.Form,
                            options: {
                                specialInput: {
                                    timeSpan: {
                                        formControlFrom: this.Form.controls.FromDate,
                                        formControlTo: this.Form.controls.ToDate,
                                    },
                                },
                            },
                        },
                        dialogData.exportType !== ClockInExportType.commission
                            ? {
                                  key: 'Mitarbeiter',
                                  formControl: this.Form.controls.Employees,
                                  options: {
                                      specialInput: {
                                          chipAutocomplete: {
                                              MapFn: (option: EmployeeEntity) => option.DisplayName,
                                              CompareFn: (a: EmployeeEntity, b: EmployeeEntity) => a.Id === b.Id,
                                              Options$: this.filteredEmployees$,
                                              initialPatchDefaultValue: true,
                                              removeAllButton: true,
                                              removeAllButtonText: 'Mitarbeiterliste leeren',
                                          },
                                      },
                                  },
                              }
                            : !dialogData.selectedCommissionId
                            ? {
                                  key: commissionLabel,
                                  formControl: this.Form.controls.Commission,
                                  options: {
                                      specialInput: {
                                          singleSelectSearch: {
                                              options: activeCommissions,
                                              compareOptions: (a: CommissionEntity, b: CommissionEntity) => a?.Id === b?.Id,
                                          },
                                      },
                                  },
                              }
                            : null,
                        {
                            key: 'Nach Stempelart ausgeben',
                            formControl: this.Form.controls.ByClockInType,
                            options: {
                                type: CustomPropertyType.Boolean,
                                specialInput: { boolean: true },
                            },
                        },
                        {
                            key: 'Nur Tage mit Arbeitszeit ausgeben',
                            formControl: this.Form.controls.WithoutEmptyWorkdays,
                            options: {
                                type: CustomPropertyType.Boolean,
                                specialInput: { boolean: true },
                            },
                        },
                    ].filter(isNotNullOrUndefined),
                })),
            );
        } else {
            throw new Error('ExportType not set');
        }

        firstValueFrom(store.select(getCommissionsFetched)).then((fetched) => {
            if (!fetched) {
                commissionResolver.resolve();
            }
        });
        firstValueFrom(store.select(getJobSpecificationFetched)).then((fetched) => {
            if (!fetched) {
                jobSpecificationResolver.resolve();
            }
        });
    }
    Export() {
        this.ls.startLoading('export-clock-ins-csv');
        this.store
            .select(getToken)
            .pipe(filter(isNotNullOrUndefined), take(1))
            .subscribe((token) => {
                const documentData = {
                    FromDate: FrontendDate(this.Form.value.FromDate.toDate(), true),
                    ToDate: FrontendDate(this.Form.value.ToDate.toDate(), true),
                    EmployeeIds: this.Form.value.Employees.map((e) => e.Id),
                    CommissionId: this.Form.value.Commission?.Id,
                    ByClockInType: this.Form.value.ByClockInType,
                    WithoutEmptyWorkdays: this.Form.value.WithoutEmptyWorkdays,
                };
                const httpRequest = new XMLHttpRequest();
                httpRequest.open('Post', this.httpService.GetUrl('Files/', 'gateway') + 'ClockIn/ExportCSV/' + this.apiEndpoint, true);
                httpRequest.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                httpRequest.setRequestHeader('Authorization', 'Bearer ' + token);
                httpRequest.responseType = 'blob';
                httpRequest.onreadystatechange = () => {
                    if (httpRequest.readyState === 4) {
                        this.ls.endLoading('export-clock-ins-csv');
                        if (httpRequest.status === 200 || httpRequest.status === 304) {
                            saveAs(httpRequest.response, this.responseFileNameOverride);
                            this.dialogRef.close();
                        } else {
                            this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Zeiten exportieren fehlgeschlagen.' } }));
                        }
                    }
                };
                httpRequest.send(JSON.stringify(documentData));
            });
    }
}
